const PROJECT_TYPES = {
    photoStory: 'PHOTOSTORY',
    quotes: 'QUOTES',
    memory: 'MEMORY',
    rankBattle: 'RANK_BATTLE',
    beforeAfter: 'BEFORE_AFTER',
    blockArticle: 'NEW_BLOCK_ARTICLE',
}

Object.freeze(PROJECT_TYPES)

export default PROJECT_TYPES
